import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import { MAKE_ROUTE_PATH } from '../components/shared/constants';

const BrandRoute = (
  <Route
    key="brand/:brand_slug"
    path={MAKE_ROUTE_PATH}
    handle={{
      clientSide: false,
      pageName: MParticlePageName.Brand,
    }}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'marketplace' */
        '../components/marketplace/marketplace_page_wrapper'
      )).default,
    })}
  />
);

export { BrandRoute };
